<template>
  <div class="h-full overflow-hidden rounded-sm  bg-white text-gray-600 shadow-lg px-10 py-5 text-left">
  <!-- server message -->
  <p class="mb-2 animate__animated text-center" :class="serverMessage.err ? ['border rounded-sm overflow-hidden border-pink-500 bg-pink-100 p-2 text-pink-500 animate__headShake'] : ['animate__rubberBand border rounded-sm overflow-hidden border-green-500 bg-green-100 p-2 text-green-500'] " v-if="serverMessage.val" v-html="serverMessage.val"></p>

  <h1 class="text-2xl font-extralight">Security Access</h1>
  <hr>
  <p class="my-2 mb-4 text-sm">Please ensure to enter a valid information to avoid inconvenience </p>
  
  <form @submit.prevent="submitForm">

    <!-- email address -->
    <p class="text-left font-bold my-2 flex items-center justify-start">
      Email Address 
      <span class="ml-1" title="Read only.">
          <svg alt="reaonly" xmlns="http://www.w3.org/2000/svg" class="h-5" viewBox="0 0 24 24" style="fill:currentColor;transform:;-ms-filter:"><path d="M12,2C6.486,2,2,6.486,2,12s4.486,10,10,10s10-4.486,10-10S17.514,2,12,2z M12,20c-4.411,0-8-3.589-8-8s3.589-8,8-8 s8,3.589,8,8S16.411,20,12,20z"></path><path d="M11 11H13V17H11zM11 7H13V9H11z"></path></svg>
      </span>
    </p>
    <div title="Read only." class="cursor-not-allowed w-full flex items-center justify-start rounded-md border p-2 border-gray-400 text-gray-400">
      <p class="flex-auto">{{emailAddress.val}}</p>
    </div>

    <!-- username -->
    <p class="text-left font-bold my-2 flex items-center justify-start">
      Username
      <span class="ml-1" title="Read only.">
          <svg alt="reaonly" xmlns="http://www.w3.org/2000/svg" class="h-5" viewBox="0 0 24 24" style="fill:currentColor;transform:;-ms-filter:"><path d="M12,2C6.486,2,2,6.486,2,12s4.486,10,10,10s10-4.486,10-10S17.514,2,12,2z M12,20c-4.411,0-8-3.589-8-8s3.589-8,8-8 s8,3.589,8,8S16.411,20,12,20z"></path><path d="M11 11H13V17H11zM11 7H13V9H11z"></path></svg>
      </span>
    </p>
    <div title="Read only." class="cursor-not-allowed flex items-center justify-start rounded-md border p-2 mt-2 mb-1  border-gray-400 text-gray-400" >
      <p class="flex-auto">{{username.val}}</p>
    </div>

    <!-- password -->
    <p class="text-left font-bold my-2 flex items-center justify-start">
      New Password
    </p>
    <div class="flex items-center justify-start rounded-md border p-2 mt-2 mb-1 border-gray-500">
      <input class="flex-auto placeholder-gray-500 focus:placeholder-gray-300" @keyup="validatePassword" :type="password.show ? 'text':'password'" :name="password.name"  :placeholder="password.name" v-model.trim="password.val">
      <button type="button" class="mr-1" @click="password.show = !password.show">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" v-if="password.show">
          <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
          <path fill-rule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clip-rule="evenodd" />
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" v-else>
          <path fill-rule="evenodd" d="M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z" clip-rule="evenodd" />
          <path d="M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z" />
        </svg>
      </button>
    </div>
    <p class="animate__animated animate__headShake text-left text-pink-500" v-if="password.err">{{password.err}}</p>

    <!-- confirm password -->
    <p class="text-left font-bold my-2 flex items-center justify-start">
      Confirm New Password
    </p>
    <div class="flex items-center justify-start rounded-md border p-2 mt-2 mb-1 border-gray-500">
      <input class="flex-auto placeholder-gray-500 focus:placeholder-gray-300" :type="confirmPassword.show ? 'text':'password'" :name="confirmPassword.name"  :placeholder="confirmPassword.name" v-model.trim="confirmPassword.val">
      <button type="button" class="mr-1" @click="confirmPassword.show = !confirmPassword.show">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" v-if="confirmPassword.show">
          <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
          <path fill-rule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clip-rule="evenodd" />
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" v-else>
          <path fill-rule="evenodd" d="M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z" clip-rule="evenodd" />
          <path d="M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z" />
        </svg>
      </button>
    </div>
    <p class="animate__animated animate__headShake text-left text-pink-500" v-if="confirmPassword.err">{{confirmPassword.err}}</p>

    <div class="text-left mb-2 mt-4" >
      <p><b>NOTE</b>: Password is required to meet the following rules: <br /></p>
      <ul class="list-disc ml-8">
        <li :class="{ 'password-met' : password.rules.includes('M') }">minimum of 6 characters long</li>
        <li :class="{ 'password-met' : password.rules.includes('U') }">at least one upper case letters</li>
        <li :class="{ 'password-met' : password.rules.includes('L') }">at least one lower case letters</li>
        <li :class="{ 'password-met' : password.rules.includes('D') }">at least one number</li>
        <li :class="{ 'password-met' : password.rules.includes('S') }">at least one special character</li>
      </ul>
    </div>

    <div class="flex items-center justify-end mt-5">
      <router-link  class="rounded-md p-2 px-4" to="/">Cancel</router-link>
      <button type="submit" class=" w-2/12 bg-blue-700 hover:bg-blue-600 text-white font-bold rounded-md p-2">Update</button>
    </div>

  </form> 

</div>  
</template>

<script>
import { ref } from 'vue';
import { useStore } from 'vuex';

export default {
  setup() {

    const store = useStore();

    const username = ref({
      name:"Username",
      val:"",
      err:"",
    });
    const password = ref({
      name:"New Password",
      val:"",
      err:"",
      show: false,
      rules:[]
    });      
    const confirmPassword = ref({
      name:"Confirm New Password",
      val:"",
      err:"",
      show: false
    });
    
    const emailAddress = ref({
      name:"Email Address",
      val:"",
      err:"",
    });


    const serverMessage = ref({
      val:"",
      err: false,
    })

    function clearForm(){
      password.value.val = "";
      confirmPassword.value.val = "";
      serverMessage.value.val = "";

      password.value.err = "";
      password.value.rules = [];
      confirmPassword.value.err = "";
      serverMessage.value.err = false;
    }
    
    async function submitForm(){
      const isReset = await resetError(); 
      if(isReset){
        const isValidated = await validateForm();
        if(isValidated){
          const form = {
            password : password.value.val,
            confirmPassword : confirmPassword.value.val,
          }
          try {
            const data = await store.dispatch("accountModule/resetPasswordForm", form);
            clearForm();
            serverMessage.value.val = data.message;
              setTimeout(() => {
                clearServerMessage();
            }, 5000);

          } catch (error) {

            if(error.msg){
              serverMessage.value.val = error.msg;
              serverMessage.value.err = true;
              setTimeout(() => {
                clearServerMessage();
              }, 3000);
            } 

            if(error.errors){
              error.errors.forEach(element => {
                this[element.param].err = element.msg;

                if(element.param === 'resetToken'){
                  serverMessage.value.val = element.msg;
                  serverMessage.value.err = true;
                }
              });
            }
          }
        }
      }
    }

    function clearServerMessage(){
      serverMessage.value.val = "";
      serverMessage.value.err = false;
    }

    function resetError(){
      return new Promise((resolve)=>{
        password.value.err = "";
        password.value.rules = [];
        confirmPassword.value.err = "";
        resolve(true);
      })  
    }

    // REGEX
    const REGEX = {
       PASSWORD_U: /^(?=.*[A-Z]).{0,}$/ // eslint-disable-line
      ,PASSWORD_L: /^(?=.*[a-z]).{0,}$/ // eslint-disable-line
      ,PASSWORD_D: /^(?=.*[0-9]).{0,}$/ // eslint-disable-line
      ,PASSWORD_S: /^(?=.*[!@#?]).{0,}$/ // eslint-disable-line
    }
    
    function validateForm(){
      return new Promise((resolve)=>{

        const requireStr = " is required.";
        
        // password
        if(!password.value.val){
            password.value.err =  password.value.name + requireStr;
        }else {
          
          if(password.value.val.length >= 6){
            password.value.rules.push("M")
          }          
          if(REGEX.PASSWORD_U.test(password.value.val)){
            password.value.rules.push("U")
          }
          if(REGEX.PASSWORD_L.test(password.value.val)){
            password.value.rules.push("L")
          }
          if(REGEX.PASSWORD_D.test(password.value.val)){
            password.value.rules.push("D")
          }
          if(REGEX.PASSWORD_S.test(password.value.val)){
            password.value.rules.push("S")
          }
          
          if(password.value.rules.length != 5){
            password.value.err = password.value.name + " must meet the rules stated.";
          }

        }

        // confirm password
        if(!confirmPassword.value.val){
          confirmPassword.value.err =  confirmPassword.value.name + requireStr;
        }else if(confirmPassword.value.val != password.value.val && password.value.val){
          confirmPassword.value.err = "Password do not match."
        }

        resolve(!password.value.err && !confirmPassword.value.err);

      })  
    }

    async function loadAccountInformation(){
      try {
        const { user } = await store.dispatch("accountModule/loadAccount")   
          emailAddress.value.val = user.emailAddress;   
          username.value.val = user.username;   

      } catch (error) {
        if(error.msg){
          serverMessage.value.val = error.msg;
          serverMessage.value.err = true;
          setTimeout(() => {
            clearServerMessage();
          }, 3000);
        } 
      }
    }

    function validatePassword(){

        // password 
        password.value.rules = [];       
        if(password.value.val.length !== 0 && password.value.val.length >= 6){
          password.value.rules.push("M")
        }          
        if(REGEX.PASSWORD_U.test(password.value.val)){
          password.value.rules.push("U")
        }
        if(REGEX.PASSWORD_L.test(password.value.val)){
          password.value.rules.push("L")
        }
        if(REGEX.PASSWORD_D.test(password.value.val)){
          password.value.rules.push("D")
        }
        if(REGEX.PASSWORD_S.test(password.value.val)){
          password.value.rules.push("S")
        }

    }
      
    loadAccountInformation();

    return{
      username, password, confirmPassword, emailAddress, submitForm, serverMessage, validatePassword
    }

    
  }
}
</script>

<style>
.password-met::after{
  content: "✔";
  @apply text-green-500 ml-2;
}
/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill:rgba(0, 0, 0, 1);transform:;-ms-filter:"><path d="M20.205,4.791c-1.137-1.131-2.631-1.754-4.209-1.754c-1.483,0-2.892,0.552-3.996,1.558 c-1.104-1.006-2.512-1.558-3.996-1.558c-1.578,0-3.072,0.623-4.213,1.758c-2.353,2.363-2.352,6.059,0.002,8.412L12,21.414 l8.207-8.207C22.561,10.854,22.562,7.158,20.205,4.791z"></path></svg> */
</style>